import React, { useEffect, useState} from 'react';
import axios from 'axios';
import {Navbar} from 'react-bootstrap';
import './history.css';
import {useNavigate} from "react-router-dom"
import { useIdleTimer } from 'react-idle-timer'
import Swal from 'sweetalert2';
import ScaleLoader from "react-spinners/ScaleLoader";

function History(){
  const [Items, setItems] = useState([]);
  const [loading, setLoading] = useState(false)

    useEffect(() => {
        setLoading(true)
        setTimeout( () => {
            setLoading(false)
        }, 800)

    },[])

  //get data 
useEffect(() => {
      let orderid = localStorage.getItem('orderid') 
  axios.get(`https://peaceful-garden-23768.herokuapp.com/api/order/history/${orderid}`)
  .then(response => {
    setItems(response.data)
  })
  .catch(err => console.log(err))
}, []);

const navigate = useNavigate()

const handleOnIdle = () => {
  Swal.fire({
    icon: 'error',
    title: 'Oops...',
    text: 'You were idle for too long!',
  })
  navigate('/idle')
}

useIdleTimer({
  timeout: 1000 * 60 * 10,
  onIdle: handleOnIdle,
})



  return(
    <div>  { loading ?  
      <div className='spinner'>
      <ScaleLoader color={'#ffa500'} loading={loading} size={30}/>
      </div>
     : 
    <div>
    <Navbar style={{background: '#ffa500', display: 'flex', justifyContent: 'space-between'}}>  
    <h3 style={{color:'white',  marginLeft:20 }}>Burger Tech</h3>
    </Navbar>
       

        <h4>Order History</h4> 
        <table width='100%'>
          <thead>
            <tr>
              <th>Product</th>
              <th>Quantity</th>
              <th>Price</th>
            </tr>
          </thead>

          <tbody>
          {Items.length > 0 && Items.map((item, i) => (
            <tr key={i} className='historyRow'>
              <td className="productHistory">
                <img src={item.img} width='150px' alt=''/>
                {item.product_name}
                </td>

              <td>{item.quantity}</td>
              <td>${item.price * item.quantity}</td>
            </tr>
          ))}
          </tbody>
          </table>

          

          <div className='buttonback'>
          <button onClick={()=>navigate('/Browse')} style={{background: '#F7931E', border: '1px solid white', color: 'white', borderRadius: '15px', padding: '15px 40px', fontWeight: 'bold', outline: 0 }}>Back to Menu</button>
          </div>
    </div>  
     }
     </div>
    
  ) 
}

export default History;